import { render, staticRenderFns } from "./ThirdPartyAppDeveloperForm.vue?vue&type=template&id=2db5bb85"
import script from "./ThirdPartyAppDeveloperForm.vue?vue&type=script&lang=js"
export * from "./ThirdPartyAppDeveloperForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports